export default __webpack_public_path__ + "static/media/onboarding-aside.b37fd579.png";